var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "businessLogisticsCompanyBusiness.table.abbreviation"
                ),
                prop: "name",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("businessLogisticsCompanyBusiness.table.full"),
                prop: "logisticsName",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.logisticsName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "logisticsName", $$v)
                  },
                  expression: "form.logisticsName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "businessLogisticsCompany.table.logisticsCompanyName"
                ),
                prop: "companyId",
              },
            },
            [
              _c("BjSelectLogisticCompany", {
                attrs: {
                  "default-options": {
                    label: _vm.form.companyName,
                    value: _vm.form.companyId,
                  },
                  clearable: "",
                },
                model: {
                  value: _vm.form.companyId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "companyId", $$v)
                  },
                  expression: "form.companyId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "businessLogisticsCompanyBusiness.table.priority"
                ),
                prop: "sortNum",
              },
            },
            [
              _c("el-input-number", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  min: 0,
                  max: _vm.MAX_LENGTH.PRIORITY,
                  precision: 0,
                  controls: false,
                },
                model: {
                  value: _vm.form.sortNum,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sortNum", $$v)
                  },
                  expression: "form.sortNum",
                },
              }),
              _c("span", { staticClass: "text-muted font12 ml0" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "businessLogisticsCompanyBusiness.dialog.priorityMessage"
                    )
                  )
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }